import PolicyLayout from './PolicyLayout';

export default function DisclaimerPage() {
  return (
    <PolicyLayout
      title="Disclaimer"
      subtitle="Important information about the nature and limitations of DotCall."
    >
      <p>
        The information, tools, AI-generated voice content, and services provided by DotCall ("Services") are
        offered on an "as is" and "as available" basis for general business use. By accessing or using the
        Services, you acknowledge and agree to this Disclaimer in addition to our Terms &amp; Conditions and
        Privacy Policy.
      </p>

      <h2>1. AI-Generated Content</h2>
      <p>DotCall uses advanced large language models (including the OpenAI Realtime API) to generate voice
        responses during calls. While we strive for high accuracy and natural conversation, AI-generated output
        may occasionally contain errors, omissions, or responses that are outside the intended scope. You
        acknowledge that:</p>
      <ul>
        <li>AI responses are probabilistic and not guaranteed to be factually correct.</li>
        <li>The Services are <strong>not</strong> a substitute for professional advice in legal, medical,
          financial, tax, or similar regulated domains.</li>
        <li>You are responsible for reviewing agent prompts, knowledge-base content, and call outputs before
          deploying AI agents to real customers.</li>
      </ul>

      <h2>2. No Professional Advice</h2>
      <p>Nothing communicated by a DotCall AI voice agent or any content on our website should be construed as
        professional advice. Always consult a qualified professional before making decisions in regulated or
        high-stakes matters.</p>

      <h2>3. Telecom &amp; Regulatory Compliance</h2>
      <p>You are solely responsible for ensuring that your use of the Services complies with all applicable
        laws, including but not limited to:</p>
      <ul>
        <li>The Telecom Commercial Communications Customer Preference Regulations (TCCCPR), 2018 issued by TRAI.</li>
        <li>Do Not Disturb (DND) and Do Not Call (DNC) registry requirements.</li>
        <li>Consumer protection, privacy, and data-protection laws applicable to you and your customers.</li>
      </ul>
      <p>DotCall does not warrant that any specific use of the platform is compliant in your jurisdiction or
        industry. You must obtain your own legal counsel before deploying outbound calling campaigns.</p>

      <h2>4. Third-Party Services</h2>
      <p>DotCall integrates with third-party services including Twilio, OpenAI, Razorpay, Shopify, WooCommerce,
        HubSpot, and others. We are not responsible for the availability, accuracy, or policies of these third
        parties. Your use of third-party services is governed by their own terms and privacy policies.</p>

      <h2>5. No Warranty</h2>
      <p>To the maximum extent permitted by law, DotCall disclaims all warranties, express or implied, including
        but not limited to merchantability, fitness for a particular purpose, non-infringement, and
        uninterrupted or error-free operation of the Services.</p>

      <h2>6. Forward-Looking Statements</h2>
      <p>Marketing materials on our website may include forward-looking statements about capabilities, benefits,
        performance benchmarks, and outcomes (e.g., "30% delivery recovery", "96% containment rate"). These are
        illustrative and based on prior client case studies; actual results will vary based on your
        industry, use case, customer base, agent configuration, and call volume.</p>

      <h2>7. External Links</h2>
      <p>Our website may contain links to external sites. We do not endorse and are not responsible for the
        content, accuracy, or practices of any external site.</p>

      <h2>8. Limitation of Liability</h2>
      <p>In no event shall DotCall be liable for any direct, indirect, incidental, consequential, or punitive
        damages arising out of reliance on AI-generated content, Service downtime, third-party failures, or
        any use or inability to use the Services, except as specifically provided in our Terms &amp; Conditions.</p>

      <h2>9. Contact</h2>
      <p>For any clarifications regarding this Disclaimer, please contact us at
        <strong> support@dotcall.io</strong> or <strong>+91 88798 51335</strong>.</p>
    </PolicyLayout>
  );
}
